import { render, staticRenderFns } from "./addAlarm.vue?vue&type=template&id=4cde6d3e&scoped=true&"
import script from "./addAlarm.vue?vue&type=script&lang=js&"
export * from "./addAlarm.vue?vue&type=script&lang=js&"
import style0 from "./addAlarm.vue?vue&type=style&index=0&id=4cde6d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde6d3e",
  null
  
)

export default component.exports